<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/personList' }">人员</el-breadcrumb-item>
                <el-breadcrumb-item>人员{{ type == 'update' ? '编辑' : '新增' }}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <el-button size="small" plain @click="submit('submitForm')" :loading="btnLoading">保存</el-button>
                    <el-button size="small" plain @click="cancel">取消</el-button>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <el-form :model="formData" :rules="rules" ref="submitForm" label-position="right" class="details_temp2023">
                        <template v-for="(item, index) in colData">
                            <template v-if="formData.hasOwnProperty(item.prop)">
                                <el-form-item
                                    v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop]['type'] == 'dropdown'"
                                    :key="index"
                                    :label="fieldTypeMap[item.prop]['title'] + '：'"
                                    :rules="rules[item['prop']] || []"
                                    :prop="item['prop']"
                                >
                                    <vDropdown
                                        :model_key="item['prop']"
                                        :model_name="'请选择' + fieldTypeMap[item.prop]['title']"
                                        :model_value_default="data[item['prop']]"
                                        :request_uri="fieldTypeMap[item.prop]['request_uri']"
                                        @onDropChange="onDropChange"
                                        :display_name="fieldTypeMap[item.prop]['display_name']"
                                        :select_value="fieldTypeMap[item.prop]['select_value']"
                                        :ref="fieldTypeMap[item.prop]['ref']"
                                        :is_disable="type == 'update' && item['prop'] == 'parent_rid'"
                                    ></vDropdown>

                                    <el-tooltip
                                        v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop].hasOwnProperty('tips')"
                                        class="Tooltip"
                                        effect="dark"
                                        :content="fieldTypeMap[item.prop]['tips']"
                                        placement="top-start"
                                    >
                                        <i class="el-icon-question"></i>
                                    </el-tooltip>
                                </el-form-item>

                                <el-form-item
                                    v-else-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop]['type'] == 'date'"
                                    :key="index"
                                    :label="fieldTypeMap[item.prop]['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <el-date-picker
                                        v-model="formData[item['prop']]"
                                        :type="fieldTypeMap[item.prop]['date_type']"
                                        :placeholder="'请选择' + fieldTypeMap[item.prop]['title']"
                                        :format="fieldTypeMap[item.prop]['format']"
                                        :value-format="fieldTypeMap[item.prop]['value_format']"
                                        size="mini"
                                        clearable
                                    >
                                    </el-date-picker>

                                    <el-tooltip
                                        v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop].hasOwnProperty('tips')"
                                        class="Tooltip"
                                        effect="dark"
                                        :content="fieldTypeMap[item.prop]['tips']"
                                        placement="top-start"
                                    >
                                        <i class="el-icon-question"></i>
                                    </el-tooltip>
                                </el-form-item>

                                <el-form-item
                                    v-else-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop]['type'] == 'cascader'"
                                    :key="index"
                                    :label="fieldTypeMap[item.prop]['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <el-cascader
                                        style="width: 100%"
                                        v-model="formData[item['prop']]"
                                        :options="provinceCities"
                                        :props="fieldTypeMap[item.prop]['subprops']"
                                        clearable
                                        filterable
                                        :ref="fieldTypeMap[item.prop]['ref']"
                                        :placeholder="'请选择' + fieldTypeMap[item.prop]['title']"
                                    ></el-cascader>
                                </el-form-item>

                                <el-form-item
                                    v-else-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop]['type'] == 'image'"
                                    :key="index"
                                    :label="fieldTypeMap[item.prop]['title'] + '：'"
                                    :prop="item['prop']"
                                    :class="has_img"
                                >
                                    <div class="upload_img" style="margin-left: 28px">
                                        <el-image
                                            style="width: 80px; height: 112px"
                                            class="img"
                                            v-if="formData[item['prop']]"
                                            :src="formData[item['prop']]"
                                            :preview-src-list="[formData[item['prop']]]"
                                        ></el-image>
                                        <el-progress
                                            v-show="person_img_percent"
                                            :percentage="person_img_percent"
                                            color="#67c23a"
                                        ></el-progress>
                                        <input type="file" accept="image/*" data-num="1" @change="checkFile" style="margin-left: 5px" />
                                    </div>
                                </el-form-item>

                                <el-form-item
                                    v-else
                                    :key="index"
                                    :label="item['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <el-input
                                        v-model="formData[item['prop']]"
                                        size="mini"
                                        :placeholder="'请输入' + item.title"
                                        :disabled="type == 'update' && item['prop'] == 'code'"
                                        clearable
                                    ></el-input>
                                </el-form-item>
                            </template>

                            <template v-else>
                                <el-form-item v-if="type == 'update'" :key="index" :label="item['title'] + '：'">
                                    <div class="read_only">
                                        {{ data[item['prop']] }}
                                    </div>
                                </el-form-item>
                            </template>
                        </template>
                    </el-form>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
import { in_array, processColDataToEdit } from '@/js/common.js';
import * as qiniu from 'qiniu-js';

export default {
    name: 'personEdit',
    data() {
        return {
            type: '', // insert or update or copy
            activeNames: ['1'],
            btnLoading: false,
            provinceCities: [], // 省份城市级联下拉
            has_img: 'has_not_img',
            person_img_percent: 0,
            colData: [], // 字段信息
            formData: {}, // 表单信息
            data: {}, // 详情数据
            fieldTypeMap: {},
            queryParams: {}, // 搜索参数（详情）
            rules: {} // 表单验证信息
        };
    },
    created() {
        this.type = this.$route.query.type;
        this.getProvinceCities();
        this.initQueryParams();
        this.selectedColData(); //筛选列
        this.initFormData();
        this.initFormRule();
        this.initFieldTypeMap();
        if (in_array(this.type, ['update', 'copy'])) {
            this.getData();
        }
    },
    methods: {
        // 选择图片上传
        checkFile(e) {
            let files = e.target.files[0];
            const isLt2M = files.size / 1024 / 1024 < 2;
            if (!files.type.match('image/*')) {
                this.$message.error('请选择图片格式的文件上传');
                return;
            }
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 2M!');
                return;
            }
            this.fileNumber = e.target.dataset.num;
            this.getToken(files);
        },
        // 获取上去七牛云的doman和token
        getToken(file) {
            let params = {};
            this.$api
                .getQiNiuToken(params)
                .then((res) => {
                    if (res.code === 0) {
                        let domain = res.data.domain;
                        let token = res.data.token;
                        this.uploadToQiniuyun(file, token, domain);
                    }
                })
                .catch((err) => {});
        },
        // 上传文件到七牛云
        uploadToQiniuyun(file, token, domain) {
            let name = String(parseInt(Math.random() * 100000)) + '_' + file.name;
            let _this = this;
            const config = {
                useCdnDomain: true,
                region: qiniu.region.z0
            };
            let api = `http://${domain}/`;
            let fileName = `person_${name}`;
            let putExtra = {
                mimeType: null
            };
            const observable = qiniu.upload(file, fileName, token, putExtra, config);
            observable.subscribe({
                next(res) {
                    _this.person_img_percent = Math.floor(res.total.percent);
                },
                error(err) {
                    switch (err.code) {
                        case 401:
                            _this.$message.error('上传失败，请检查是否登录再重试');
                            break;
                        default:
                            _this.$message.error(err.message);
                            break;
                    }
                },
                complete(res) {
                    let imgSrc = `${api}${res.key}`;
                    _this.formData['picture'] = imgSrc;
                }
            });
        },
        onDropChange(key, value) {
            this.formData[key] = value;
        },
        getProvinceCities() {
            this.$api
                .provinceCities({})
                .then((res) => {
                    if (res.code == 0) {
                        this.provinceCities = res.data;
                    }
                })
                .catch((error) => {});
        },
        initFieldTypeMap() {
            this.fieldTypeMap = {
                gender: {
                    request_uri: 'gender',
                    title: '性别',
                    ref: 'gender_ref',
                    display_name: 'name',
                    select_value: 'value',
                    type: 'dropdown'
                },
                nation: {
                    request_uri: 'nation',
                    title: '民族',
                    ref: 'nation_ref',
                    display_name: 'name',
                    select_value: 'value',
                    type: 'dropdown'
                },
                termination_type: {
                    request_uri: 'leftDateType',
                    title: '离职类型',
                    ref: 'termination_type_ref',
                    display_name: 'name',
                    select_value: 'value',
                    type: 'dropdown'
                },
                political_status: {
                    request_uri: 'politicalStatus',
                    title: '政治面貌',
                    ref: 'political_status_ref',
                    display_name: 'name',
                    select_value: 'value',
                    type: 'dropdown'
                },
                marital_status: {
                    request_uri: 'maritalStatus',
                    title: '婚姻状况',
                    ref: 'marital_status_ref',
                    display_name: 'name',
                    select_value: 'value',
                    type: 'dropdown'
                },
                path: {
                    request_uri: 'path',
                    title: '发展通道',
                    ref: 'path_ref',
                    display_name: 'name',
                    select_value: 'value',
                    type: 'dropdown'
                },
                // rank: {
                //     request_uri: 'personRank',
                //     title: '职级',
                //     ref: 'rank_ref',
                //     display_name: 'name',
                //     select_value: 'value',
                //     type: 'dropdown'
                // },
                rank_date: {
                    title: '职级认定日期',
                    format: 'yyyy-MM-dd',
                    value_format: 'yyyy-MM-dd',
                    ref: 'rank_date_ref',
                    type: 'date'
                },
                live_city_rid: {
                    title: '居住城市',
                    ref: 'live_city_rid_ref',
                    type: 'cascader',
                    subprops: {
                        value: 'rid',
                        label: 'name',
                        children: 'subs',
                        emitPath: false
                    }
                },
                social_insurance_city_rid: {
                    title: '社保缴纳地',
                    ref: 'social_insurance_city_rid_ref',
                    type: 'cascader',
                    subprops: {
                        value: 'rid',
                        label: 'name',
                        children: 'subs',
                        emitPath: false
                    }
                },
                plan_formaldate: {
                    title: '计划转正日期',
                    format: 'yyyy-MM-dd',
                    value_format: 'yyyy-MM-dd',
                    ref: 'plan_formaldate_ref',
                    type: 'date'
                },
                joined_job_date: {
                    title: '参加工作时间',
                    format: 'yyyy-MM-dd',
                    value_format: 'yyyy-MM-dd',
                    ref: 'joined_job_date_ref',
                    type: 'date'
                },
                formaldate: {
                    title: '转正日期',
                    format: 'yyyy-MM-dd',
                    value_format: 'yyyy-MM-dd',
                    ref: 'formaldate_ref',
                    type: 'date',
                    tips: '转正日期到期后，系统会自动修改转正状态，如果转正前离职，请手动修改转正日期'
                },
                date_of_joining: {
                    title: '入职日期',
                    format: 'yyyy-MM-dd',
                    value_format: 'yyyy-MM-dd',
                    ref: 'date_of_joining_ref',
                    type: 'date',
                    tips: '入职日期请按实填写'
                },
                date_of_termination: {
                    title: '离职日期',
                    format: 'yyyy-MM-dd',
                    value_format: 'yyyy-MM-dd',
                    ref: 'date_of_termination_ref',
                    type: 'date',
                    tips: '离职日期到期后，系统会自动修改人员状态，以及将其的所有任职记录卸职'
                },
                registered_residence_rid: {
                    request_uri: 'provinces',
                    title: '户口所在地',
                    ref: 'registered_residence_rid_ref',
                    display_name: 'name',
                    type: 'dropdown'
                },
                picture: {
                    title: '照片',
                    ref: 'picture_ref',
                    type: 'image'
                },
                authentication_rid: {
                    request_uri: 'dropdownBiAccounts',
                    title: 'BI凭据',
                    ref: 'authentication_rid_ref',
                    display_name: 'name',
                    select_value: 'rid',
                    type: 'dropdown'
                },
            };
        },
        initFormRule() {
            this.rules = {
                code: [{ required: true, message: '请输入代码', trigger: 'blur' }],
                name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
                mobile: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
                email: [{ required: true, message: '请输入电子邮件', trigger: 'blur' }],
                date_of_joining: [{ required: true, message: '请输入入职日期', trigger: 'blur' }]
            };
        },
        initQueryParams() {
            this.queryParams.rid = this.$route.query.id;
        },
        initFormData() {
            this.formData = {
                rid: this.data.rid || '',
                code: this.data.code || '',
                name: this.data.name || '',
                id_number: this.data.id_number || '',
                mobile: this.data.mobile || '',
                email: this.data.email || '',
                dingtalk_user_id: this.data.dingtalk_user_id || '',
                gender: this.data.gender || '',
                nation: this.data.nation || '',
                political_status: this.data.political_status || '',
                picture: this.data.picture || '',
                extension_number: this.data.extension_number || '',
                remark: this.data.remark || '',
                authentication_rid: this.data.authentication_rid || '',
                birthplace: this.data.birthplace || '',
                marital_status: this.data.marital_status || '',
                registered_residence_rid: this.data.registered_residence_rid || '',
                live_city_rid: this.data.live_city_rid || '',
                home_address: this.data.home_address || '',
                emergency_contact: this.data.emergency_contact || '',
                emergency_contact_phone: this.data.emergency_contact_phone || '',
                joined_job_date: this.data.joined_job_date || '',
                social_insurance_city_rid: this.data.social_insurance_city_rid || '',
                housing_fund_code: this.data.housing_fund_code || '',
                additional_housing_code: this.data.additional_housing_code || '',
                plan_formaldate: this.data.plan_formaldate || '',
                formaldate: this.data.formaldate || '',
                termination_type: this.data.termination_type || '',
                termination_reason: this.data.termination_reason || '',
                path: this.data.path || '',
                date_of_joining: this.data.date_of_joining || '',
                date_of_termination: this.data.date_of_termination || '',
                rank: this.data.rank || '',
                rank_date: this.data.rank_date || ''
            };

            if (this.formData.picture != '') {
                this.has_img = 'has_img';
            } else {
                this.has_img = 'has_not_img';
            }
        },
        //筛选列
        selectedColData() {
            let temp = JSON.parse(localStorage.getItem('detailList')).person;

            processColDataToEdit(
                temp,
                this,
                {
                    white: [
                        'code',
                        'name',
                        'id_number',
                        'mobile',
                        'email',
                        'dingtalk_user_id',
                        'picture',
                        'extension_number',
                        'remark',
                        'authentication_rid',
                        'birthplace',
                        'home_address',
                        'emergency_contact',
                        'emergency_contact_phone',
                        'joined_job_date',
                        'housing_fund_code',
                        'additional_housing_code',
                        'plan_formaldate',
                        'formaldate',
                        'termination_reason',
                        'date_of_joining',
                        'date_of_termination',
                        'rank',
                        'rank_date'
                    ]
                },
                {
                    gender_label: 'gender',
                    nation_label: 'nation',
                    termination_type_label: 'termination_type',
                    political_status_label: 'political_status',
                    marital_status_label: 'marital_status',
                    path_label: 'path',
                    social_insurance_city_name: 'social_insurance_city_rid',
                    live_city_name: 'live_city_rid',
                    registered_residence_name: 'registered_residence_rid'
                }
            );
        },
        //取消
        cancel() {
            if (window.history.length <= 1) {
                this.$router.push({ path: '/personList' });
            } else {
                this.$router.go(-1);
            }
        },
        //获取详情
        getData() {
            this.$api
                .personDetail(this.queryParams)
                .then((res) => {
                    this.data = res.data;
                    this.initFormData();
                })
                .catch((error) => {});
        },
        //提交新增/编辑修改
        submit(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.doSubmit();
                    return true;
                } else {
                    return false;
                }
            });
        },
        doSubmit() {
            this.btnLoading = true;
            let uri = '';
            if (this.type == 'update') {
                uri = 'personUpdate';
            } else {
                uri = 'personInsert';
            }
            this.$api[uri](this.formData)
                .then((res) => {
                    this.btnLoading = false;
                    this.$message({
                        message: '保存成功！',
                        type: 'success'
                    });
                    this.cancel();
                })
                .catch((error) => {
                    this.btnLoading = false;
                });
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
.has_img {
    margin-right: -32px !important;
}
</style>